import { render, staticRenderFns } from "./UpdateAplicacion.vue?vue&type=template&id=4f1525b1"
import script from "./UpdateAplicacion.vue?vue&type=script&lang=js"
export * from "./UpdateAplicacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports